import Vue from 'vue'
import numeral from 'numeral'
// import webp from 'v-webp'

Vue.filter('formatMoney', (val) => {
  return numeral(val).format('0,0')
})

Vue.filter('firstLetterBig', (val) => {
  return `<strong>${val.charAt(0)}</strong>${val}`
})

Vue.filter('validationClass', (errors, valid) => {
  if (errors) return 'is-invalid'
  if (valid) return 'is-valid'
  return ''
})

// Vue.filter('webp', (url) => {
//   if (webp.isSupportWebp) {
//     url = url.replace('wp-content/uploads', 'wp-content/uploads-webpc/uploads')
//     return `${url}.webp`
//   }
//   return url
// })
